/**
 * AI Agent 관련 상수
 */

import { Clock, Loader2, AlertCircle, CheckCircle, XCircle } from 'lucide-react';
import { AgentRunStatus } from '@/lib/api/orval/models/agentRunStatus';

/**
 * AI Agent 실행 상태별 설정
 */
export const AGENT_RUN_STATUS_CONFIG: Record<
  string,
  {
    label: string;
    variant: 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'neutral';
    icon: typeof Clock;
  }
> = {
  [AgentRunStatus.pending]: { label: '대기 중', variant: 'neutral', icon: Clock },
  [AgentRunStatus.analyzing_trends]: { label: '트렌드 분석 중', variant: 'primary', icon: Loader2 },
  [AgentRunStatus.generating_ideas]: { label: '아이디어 생성 중', variant: 'primary', icon: Loader2 },
  [AgentRunStatus.awaiting_approval]: { label: '승인 대기', variant: 'warning', icon: AlertCircle },
  [AgentRunStatus.creating_playlist]: { label: '플레이리스트 생성 중', variant: 'primary', icon: Loader2 },
  [AgentRunStatus.generating_music]: { label: '음악 생성 중', variant: 'primary', icon: Loader2 },
  [AgentRunStatus.generating_thumbnail]: { label: '썸네일 생성 중', variant: 'primary', icon: Loader2 },
  [AgentRunStatus.generating_description]: { label: '설명 생성 중', variant: 'primary', icon: Loader2 },
  [AgentRunStatus.completed]: { label: '완료', variant: 'success', icon: CheckCircle },
  [AgentRunStatus.failed]: { label: '실패', variant: 'error', icon: XCircle },
  [AgentRunStatus.cancelled]: { label: '취소됨', variant: 'neutral', icon: XCircle },
};

/**
 * 활성 상태 목록 (진행 중인 상태들)
 */
export const ACTIVE_RUN_STATUSES = [
  AgentRunStatus.pending,
  AgentRunStatus.analyzing_trends,
  AgentRunStatus.generating_ideas,
  AgentRunStatus.creating_playlist,
  AgentRunStatus.generating_music,
] as const;

/**
 * 지역 코드 레이블
 */
export const REGION_LABELS: Record<string, string> = {
  US: '🇺🇸 미국',
  KR: '🇰🇷 한국',
  JP: '🇯🇵 일본',
  GB: '🇬🇧 영국',
  DE: '🇩🇪 독일',
  FR: '🇫🇷 프랑스',
  BR: '🇧🇷 브라질',
  IN: '🇮🇳 인도',
} as const;


